export const RESET_STATE = "@inventories/RESET_STATE";
export const SET_ERROR = "@inventories/SET_ERROR";

export const GET_INVENTORY_REQUEST = "@inventories/GET_INVENTORY_REQUEST";
export const GET_INVENTORY_SUCCESS = "@inventories/GET_INVENTORY_SUCCESS";
export const GET_INVENTORY_FAILURE = "@inventories/GET_INVENTORY_FAILURE";

export const UPDATE_INVENTORY_REQUEST = "@inventories/UPDATE_INVENTORY_REQUEST";
export const UPDATE_INVENTORY_SUCCESS = "@inventories/UPDATE_INVENTORY_SUCCESS";
export const UPDATE_INVENTORY_FAILURE = "@inventories/UPDATE_INVENTORY_FAILURE";

export const SELECT_INVENTORY_REQUEST = "@inventories/SELECT_INVENTORY_REQUEST";
export const SELECT_INVENTORY_SUCCESS = "@inventories/SELECT_INVENTORY_SUCCESS";
export const SELECT_INVENTORY_FAILURE = "@inventories/SELECT_INVENTORY_FAILURE";

export const CREATE_INVENTORY_REQUEST = "@inventories/CREATE_INVENTORY_REQUEST";
export const CREATE_INVENTORY_SUCCESS = "@inventories/CREATE_INVENTORY_SUCCESS";
export const CREATE_INVENTORY_FAILURE = "@inventories/CREATE_INVENTORY_FAILURE";